import { PRODUCTS } from "#src/structures/ProductType.js";
import {
  START_PAGES,
  useInstanceSettingsStore,
} from "#src/stores/instance-settings.js";
import { searchToArray } from "#src/util/helpers.js";

export class InstancePrefillService {
  #pinia;

  constructor(pinia) {
    this.#pinia = pinia;
  }

  setFromPrefill(defaults, { includeQuoteData = false } = {}) {
    const instanceSettings = useInstanceSettingsStore(this.#pinia);
    const prefill = this.#normalize(defaults);

    if (prefill.test) instanceSettings.test = prefill.test;

    if (prefill.new_npn_greeting) {
      instanceSettings.new_npn_greeting = prefill.new_npn_greeting;
    }

    if (prefill.greeting) {
      instanceSettings.greeting = prefill.greeting;
    }

    if (prefill.start_page) {
      instanceSettings.start_page = prefill.start_page;
    }
    if (!includeQuoteData) return;

    if (prefill.product_types?.length) {
      Object.keys(instanceSettings.products).forEach(p => {
        instanceSettings.products[p] = prefill.product_types.includes(p);
      });
    }
  }

  #normalize(initPrefill) {
    let product_types = [];
    if (initPrefill.product_types) {
      const cleanedProductTypes = searchToArray(initPrefill.product_types).map(
        v => v.replaceAll("_", "").toLowerCase().trim()
      );
      Object.values(PRODUCTS).forEach(type => {
        const cleanedType = type.replaceAll("_", "").toLowerCase();
        if (cleanedProductTypes.includes(cleanedType)) product_types.push(type);
      });
    }

    const test = ["true", true].includes(initPrefill.test);

    let startPage;
    if (Object.values(START_PAGES).includes(initPrefill.start_page)) {
      startPage = initPrefill.start_page;
    }

    return {
      new_npn_greeting: initPrefill.new_npn_greeting,
      greeting: initPrefill.greeting,
      test,
      product_types,
      start_page: startPage,
    };
  }
}
